import React from 'react';

/**
 * EtlTiles — the count row that doubles as a filter. Clicking a tile filters
 * the table below it; clicking the active tile clears the filter, which the
 * old StatusSummaryCards had no way to express.
 *
 * tiles [{ key, label, n, tone?: 'ok'|'warn'|'error'|'info', icon?: Component }]
 */
export default function EtlTiles({ tiles = [], value, onChange }) {
  if (!tiles.length) return null;
  return (
    <div className="ep-tiles">
      {tiles.map((t) => {
        const Icon = t.icon;
        const active = value === t.key;
        return (
          <button
            key={t.key}
            type="button"
            className={`ep-tile${active ? ' ep-active' : ''}${t.tone ? ` ep-tone-${t.tone}` : ''}`}
            aria-pressed={active}
            onClick={() => onChange && onChange(active ? null : t.key)}
          >
            {Icon ? <span className="ep-tile-icon"><Icon size={16} /></span> : null}
            <span className="ep-tile-text">
              <span className="ep-tile-n">{Number(t.n || 0).toLocaleString()}</span>
              <span className="ep-tile-label">{t.label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
